const init = () => {
    const quizContainer = document.querySelector('.js-quiz');
    if (quizContainer) {
        const iframe = document.createElement('iframe');
        iframe.id = quizContainer.dataset.quizId;
        iframe.style = 'width: 100%; overflow: hidden; min-height: 700px; height: 784px; transition-duration: 600ms;';
        iframe.src = quizContainer.dataset.quizUrl;
        quizContainer.appendChild(iframe);
    }
};

export default init;
